import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Table,
  Container,
  Row,
  Col,
  Alert,
  Modal,
} from "react-bootstrap";
import axios from "axios";
import Select from "react-select"; // Import react-select

const AdminProducts = () => {
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [location, setLocation] = useState("");
  const [price, setPrice] = useState("");
  const [mapLink, setMapLink] = useState(""); // Original Google Maps link
  const [embedLink, setEmbedLink] = useState(""); // Generated embed link
  const [catId, setCatId] = useState("");
  const [filterHomeId, setFilterHomeId] = useState(""); // Home ID filter
  const [filterApartmentId, setFilterApartmentId] = useState(""); // Apartment ID filter
  const [filterRentId, setFilterRentId] = useState(""); // Rent ID filter
  const [categories, setCategories] = useState([]);
  const [homes, setHomes] = useState([]); // To hold homes data
  const [apartments, setApartments] = useState([]); // To hold apartments data
  const [rents, setRents] = useState([]); // To hold rents data
  const [products, setProducts] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [longitude, setlongitude] = useState("");
  const [Latitude, setLatitude] = useState("");
  const [agentid, setAgentId] = useState([]); // Ensure it's initialized as an array

  // Search filter states
  const [searchTitle, setSearchTitle] = useState("");
  const [searchLocation, setSearchLocation] = useState("");
  const [searchPrice, setSearchPrice] = useState("");
  const [searchCategory, setSearchCategory] = useState("");
  const [selectedAgent, setSelectedAgent] = useState(null); // Currently selected agent
  const [status, setStatus] = useState("");

  // Fetch categories for dropdown
  useEffect(() => {
    axios
      .get("https://api.biznetusa.com/api/get-category")
      .then((response) => setCategories(response.data.categories))
      .catch((error) => console.error("Error fetching categories:", error));

    axios
      .get("https://api.biznetusa.com/api/get-searchbyhome")
      .then((response) => setHomes(response.data.home_by_city))
      .catch((error) => console.error("Error fetching homes:", error));

    axios
      .get("https://api.biznetusa.com/api/get-searchbyapartment")
      .then((response) => {
        console.log("Apartments Data:", response.data.apartment_by_city);
        setApartments(response.data.apartment_by_city);
      })
      .catch((error) => console.error("Error fetching apartments:", error));

    axios
      .get("https://api.biznetusa.com/api/get-searchbyrent")
      .then((response) => setRents(response.data.rent_by_city))
      .catch((error) => console.error("Error fetching rents:", error));

    console.log("Available apartments:", apartments);
    console.log("Selected apartment ID:", filterApartmentId);
  }, []);

  useEffect(() => {
    axios
      .get("https://api.biznetusa.com/api/all-agents")
      .then((response) => {
        if (response.status === 200 && Array.isArray(response.data.allusers)) {
          // Transform the data to be used in the Select component
          const agentOptions = response.data.allusers.map((agent) => ({
            value: agent.user_role, // Assuming user_role is the identifier
            label: `${agent.roles.role_name} (${agent.name})`, // Format the label
          }));
          console.log("Agent Options:", agentOptions); // Debugging: Log out the agent options
          setAgentId(agentOptions);
        } else {
          console.error(
            "Received data is not an array or missing expected structure:",
            response.data
          );
          setAgentId([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching agents:", error);
        setAgentId([]);
      });
  }, []);
  // Fetch products
  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = () => {
    axios
      .get("https://api.biznetusa.com/api/get-products")
      .then((response) => setProducts(response.data.products))
      .catch((error) => console.error("Error fetching products:", error));
  };

  // Function to convert a Google Maps link to an embeddable link
  const convertToEmbedLink = (link) => {
    const embedLink = "https://www.google.com/maps/embed?..."; // Simplified for brevity
    setEmbedLink(embedLink);
  };

  // Handle input change for Google Maps link
  const handleMapLinkChange = (e) => {
    const link = e.target.value;
    setMapLink(link);
    convertToEmbedLink(link); // Convert the pasted link to an embed link
  };

  // Open the modal for adding a new product
  const handleAdd = () => {
    setEditingProduct(null);
    setTitle("");
    setDesc("");
    setLocation("");
    setPrice("");
    setMapLink(""); // Reset map link
    setEmbedLink(""); // Reset embed link
    setCatId("");
    setAgentId([]); // Corrected to set as an empty array
    setFilterHomeId(""); // Reset home filter
    setFilterApartmentId(""); // Reset apartment filter
    setFilterRentId(""); // Reset rent filter
    setShowModal(true);
    setlongitude("");
    setLatitude("");
  };

  const handleEdit = (product) => {
    setEditingProduct(product);
    setTitle(product.title); // Pre-populate title
    setDesc(product.desc); // Pre-populate description
    setLocation(product.location); // Pre-populate location
    setPrice(product.price); // Pre-populate price
    setMapLink(product.map_url || ""); // Pre-populate map link
    setEmbedLink(product.map_url || ""); // Pre-populate embed link
    setlongitude(product.longitude);
    setLatitude(product.latitude); // Assuming 'latitude' is the correct field name
    // Pre-populate category
    setCatId({ value: product.cat_id, label: product.categories.cat_title });
    setSelectedAgent({ value: product.agent_id, label: product.agent_name }); // Assuming these fields are available

    // Pre-populate filters (if available)
    setFilterHomeId(
      product.fliter_home_id
        ? { value: product.fliter_home_id, label: product.home_title }
        : null
    );
    setFilterApartmentId(
      product.fliter_apartment_id
        ? { value: product.fliter_apartment_id, label: product.apartment_title }
        : null
    );
    setFilterRentId(
      product.fliter_rent_id
        ? { value: product.fliter_rent_id, label: product.rent_title }
        : null
    );

    setShowModal(true);
  };

  const handleSubmit = () => {
    if (!catId || !catId.value) {
      setAlertMessage("Please select a category.");
      return;
    }

    const productData = {
      title,
      desc,
      location,
      price,
      longitude,
      latitude: Latitude,
      map_url: embedLink,
      cat_id: catId.value,
      agent_id: selectedAgent ? selectedAgent.value : null, // Sending agent ID
      fliter_home_id: filterHomeId ? Number(filterHomeId) : null,
      fliter_apartment_id: filterApartmentId ? Number(filterApartmentId) : null,
      fliter_rent_id: filterRentId ? Number(filterRentId) : null,
      status: status ? status.value : null // Ensure you are sending the value of the selected status
    };

    console.log("Product Data being sent:", productData);

    if (editingProduct) {
      // Update existing product
      axios
        .put(
          `https://api.biznetusa.com/api/update-product/${editingProduct.id}`,
          productData
        )
        .then(() => {
          setAlertMessage("Product updated successfully!");
          fetchProducts(); // Refresh products
          setShowModal(false); // Close modal
        })
        .catch((error) => {
          console.error("Error updating product:", error.response);
          setAlertMessage("Error updating product");
        });
    } else {
      // Add new product
      axios
        .post("https://api.biznetusa.com/api/store-product", productData)
        .then(() => {
          setAlertMessage("Product added successfully!");
          fetchProducts(); // Refresh products
          setShowModal(false); // Close modal
        })
        .catch((error) => {
          console.error("Error adding product:", error.response);
          setAlertMessage("Error adding product");
        });
    }
  };

  // Handle deleting a product
  const handleDelete = (productId) => {
    axios
      .delete(`https://api.biznetusa.com/api/deleteproduct/${productId}`)
      .then(() => {
        setAlertMessage("Product deleted successfully!");
        fetchProducts(); // Refresh product list
      })
      .catch((error) => console.error("Error deleting product:", error));
  };

  const filteredProducts = products.filter((product) => {
    return (
      product.title.toLowerCase().includes(searchTitle.toLowerCase()) &&
      product.location.toLowerCase().includes(searchLocation.toLowerCase()) &&
      product.price.toString().includes(searchPrice.toLowerCase()) &&
      product.categories.cat_title
        .toLowerCase()
        .includes(searchCategory.toLowerCase())
    );
  });

  const resetFormFields = () => {
    setTitle("");
    setDesc("");
    setLocation("");
    setPrice("");
    setMapLink("");
    setEmbedLink("");
    setCatId("");
    setFilterHomeId("");
    setFilterApartmentId("");
    setFilterRentId("");
    setlongitude("");
    setLatitude("");
  };

  const handleAgentChange = (selectedOption) => {
    console.log("Selected Agent:", selectedOption); // Debugging: Log the selected option
    setSelectedAgent(selectedOption);
  };

  return (
    <Container>
      <Row className="my-4">
        <Col>
          <h2>Manage Products</h2>
          {alertMessage && <Alert variant="success">{alertMessage}</Alert>}
          <Button variant="primary" onClick={handleAdd}>
            Add New Product
          </Button>
        </Col>
      </Row>
      <Row className="justify-content-end mb-4">
        <Col md={2}>
          <Form.Control
            type="text"
            placeholder="Search Title"
            value={searchTitle}
            onChange={(e) => setSearchTitle(e.target.value)}
          />
        </Col>
        <Col md={2}>
          <Form.Control
            type="text"
            placeholder="Search Location"
            value={searchLocation}
            onChange={(e) => setSearchLocation(e.target.value)}
          />
        </Col>
        <Col md={2}>
          <Form.Control
            type="text"
            placeholder="Search Price"
            value={searchPrice}
            onChange={(e) => setSearchPrice(e.target.value)}
          />
        </Col>
        <Col md={2}>
          <Form.Control
            type="text"
            placeholder="Search Category"
            value={searchCategory}
            onChange={(e) => setSearchCategory(e.target.value)}
          />
        </Col>
      </Row>
      <Row className="my-4">
        <Col>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Title</th>
                <th>Description</th>
                <th>Location</th>
                <th>Price</th>
                <th>Category</th>
                <th>Map Embed</th>
                <th>longitiude</th>
                <th>latitude</th>
                <th>status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredProducts.map((product) => (
                <tr key={product.id}>
                  <td>{product.title}</td>
                  <td>{product.desc}</td>
                  <td>{product.location}</td>
                  <td>{product.price}</td>
                  <td>{product.categories.cat_title}</td>
                  <td>
                    {product.map_url ? (
                      <iframe
                        width="600"
                        height="450"
                        frameBorder="0"
                        style={{ border: 0 }}
                        src={product.map_url}
                        allowFullScreen
                      ></iframe>
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td>{product.longitude}</td>
                  <td>{product.Latitude}</td>
                  <td>{product.status}</td>
                  <td>
                    <Button
                      variant="warning"
                      size="sm"
                      className="mr-2"
                      onClick={() => handleEdit(product)}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleDelete(product.id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>

      {/* Modal for adding and editing a product */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {editingProduct ? "Edit Product" : "Add Product"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formTitle">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formDesc">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formLocation">
              <Form.Label>Location</Form.Label>
              <Form.Control
                type="text"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formPrice">
              <Form.Label>Price</Form.Label>
              <Form.Control
                type="number"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formStatus">
              <Form.Label>Status</Form.Label>
              <Select
                options={[
                  { value: "rent", label: "Rent" },
                  { value: "on sale", label: "On Sale" },
                  { value: "sold", label: "Sold" },
                ]}
                value={status}
                onChange={(selectedOption) => setStatus(selectedOption)}
                isClearable
                placeholder="Select Status"
              />
            </Form.Group>

            <Form.Group controlId="formMapLink">
              <Form.Label>Google Maps Link</Form.Label>
              <Form.Control
                type="text"
                value={mapLink}
                onChange={handleMapLinkChange} // Update and convert the link
                placeholder="Paste Google Maps link"
              />
            </Form.Group>
            {/* Show map embed preview */}
            {embedLink && (
              <Form.Group>
                <Form.Label>Map Preview</Form.Label>
                <iframe
                  src={embedLink}
                  width="100%"
                  height="300"
                  allowFullScreen=""
                  loading="lazy"
                  title="Google Map Embed"
                ></iframe>
              </Form.Group>
            )}
            {/* Category Dropdown */}
            <Form.Group controlId="formMapLink">
              <Form.Label>longitiude</Form.Label>
              <Form.Control
                type="text"
                value={longitude}
                onChange={(e) => setlongitude(e.target.value)}
                placeholder="Enter the longtitude"
              />
            </Form.Group>
            <Form.Group controlId="formMapLink">
              <Form.Label>Latitude</Form.Label>
              <Form.Control
                type="text"
                value={Latitude}
                onChange={(e) => setLatitude(e.target.value)}
                placeholder="Enter the latitude"
              />
            </Form.Group>
            <Form.Group controlId="formCategory">
              <Form.Label>Category</Form.Label>
              <Select
                options={categories.map((cat) => ({
                  value: cat.id,
                  label: cat.cat_title,
                }))}
                value={catId} // Set the value correctly when editing
                onChange={(selectedOption) => setCatId(selectedOption)} // Update the selected option
                isClearable
              />
            </Form.Group>
            <Form.Group controlId="formAgent">
              <Form.Label>Agent</Form.Label>
              <Select
                options={agentid}
                value={selectedAgent}
                onChange={handleAgentChange}
                isClearable
                placeholder="Select an agent"
              />
            </Form.Group>

            <Form.Group controlId="formHome">
              <Form.Label>Filter by Home</Form.Label>
              <Select
                options={homes.map((home) => ({
                  value: home.id, // Ensure you're passing the correct id
                  label: home.title,
                }))}
                value={
                  homes.find((option) => option.id === filterHomeId)
                    ? {
                        value: filterHomeId,
                        label: homes.find((home) => home.id === filterHomeId)
                          ?.title,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  setFilterHomeId(selectedOption ? selectedOption.value : null)
                }
                isClearable
              />
            </Form.Group>
            <Form.Group controlId="formApartment">
              <Form.Label>Filter by Apartment</Form.Label>
              <Select
                options={apartments.map((apartment) => ({
                  value: apartment.id, // Ensure you're passing the correct ID
                  label: apartment.title,
                }))}
                value={
                  apartments.find(
                    (apartment) => apartment.id === filterApartmentId
                  )
                    ? {
                        value: filterApartmentId,
                        label: apartments.find(
                          (apartment) => apartment.id === filterApartmentId
                        )?.title,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  setFilterApartmentId(
                    selectedOption ? Number(selectedOption.value) : null
                  )
                } // Explicitly convert to number
                isClearable
              />
            </Form.Group>
            <Form.Group controlId="formRent">
              <Form.Label>Filter by Rent</Form.Label>
              <Select
                options={rents.map((rent) => ({
                  value: rent.id, // Ensure you're passing the correct id
                  label: rent.title,
                }))}
                value={
                  rents.find((option) => option.id === filterRentId)
                    ? {
                        value: filterRentId,
                        label: rents.find((rent) => rent.id === filterRentId)
                          ?.title,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  setFilterRentId(selectedOption ? selectedOption.value : null)
                }
                isClearable
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {editingProduct ? "Save Changes" : "Add Product"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AdminProducts;
